module.exports = "<div class=\"select-box\">\n  <select\n    chosen\n    style=\"width: 100%\"\n    placeholder-text=\"'Choose On-Site Manager'\"\n    ng-model=\"vm.id_for_backend\"\n    ng-options=\"contact.id as contact.str for contact in vm.contact_options.values\"\n    ng-change=\"vm.managerChanged()\"\n  >\n    <option value=\"\"></option>\n  </select>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/jobcontact/jobcontact.html
// module id = 145
// module chunks = 0